import { useRef } from "react";

import Banner from "./Banner";
import JobInformation from "./JobInformation";
import FormSection from "./FormSection";

const JobDetails = () => {
  const applyFormRef = useRef(null);

  return (
    <>
      <div className="bg-white text-gray-800">
        <Banner
          config={{
            applyFormRef,
            title: "Sales and Marketing Associate",
          }}
        />

        <div className="bg-white px-6 md:px-16 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">
    
            <div className="lg:col-span-2 space-y-12">
              <div>
                <h2 className="text-[32px] font-semibold text-[#212129] mb-6">
                  Job Summary
                </h2>

                <p className="text-[#212129] text-[18px] leading-8 mb-6">
                  We are looking for an enthusiastic and motivated fresher to
                  join our Sales and Marketing team. The ideal candidate should
                  have excellent communication skills, a passion for sales, and
                  a willingness to learn about marketing strategies and
                  techniques. You will play a key role in driving customer
                  engagement, achieving sales targets, and contributing to the
                  company’s growth.
                </p>

                <h3 className="text-[20px] font-semibold text-green-600 mb-1">
                  Key Responsibilities
                </h3>
                <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

                <h4 className="text-[18px] font-semibold text-[#212129] mb-2">
                  1. Sales Activities:
                </h4>
                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>
                    Identify potential customers and generate leads through
                    various channels.
                  </li>
                  <li>
                    Conduct sales presentations and product demonstrations.
                  </li>
                  <li>
                    Build and maintain long-term relationships with clients.
                  </li>
                  <li>Meet or exceed sales targets set by the company.</li>
                </ul>

                <h4 className="text-[18px] font-semibold text-[#212129] mt-6 mb-2">
                  2. Marketing Activities:
                </h4>
                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>Assist in planning and executing marketing campaigns.</li>
                  <li>
                    Promote products or services via online and offline
                    platforms.
                  </li>
                  <li>
                    Support the creation of marketing materials such as
                    brochures, flyers.
                  </li>
                  <li>
                    Gather and analyze customer feedback to improve marketing
                    strategies.
                  </li>
                </ul>

                <h4 className="text-[18px] font-semibold text-[#212129] mt-6 mb-2">
                  3. Customer Relationship Management:
                </h4>
                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>
                    Address customer inquiries and provide appropriate
                    solutions.
                  </li>
                  <li>
                    Ensure timely follow-ups and maintain an updated customer
                    database.
                  </li>
                </ul>

                <h4 className="text-[18px] font-semibold text-[#212129] mt-6 mb-2">
                  4. Market Research:
                </h4>
                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>
                    Conduct research to identify market trends and customer
                    needs.
                  </li>
                  <li>
                    Monitor competitor activities and suggest improvements in
                    marketing tactics.
                  </li>
                </ul>
              </div>

              <div>
                <h3 className="text-[20px] font-semibold text-green-600 mb-1">
                  Skills and Qualifications
                </h3>
                <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>
                    Bachelor’s or master's degree in marketing or business
                    administration, or a related field.
                  </li>
                  <li>Excellent verbal and written communication skills.</li>
                  <li>
                    Basic understanding of sales and marketing principles.
                  </li>
                  <li>Proficiency in MS Office Word, Excel, PowerPoint.</li>
                  <li>
                    Self-motivated, goal-oriented, and able to work
                    independently.
                  </li>
                  <li>
                    Knowledge of digital marketing or CRM tools is an Added
                    Advantage.
                  </li>
                </ul>
              </div>
              <div>
                <h3 className="text-[20px] font-semibold text-green-600 mb-1">
                  Benefits
                </h3>
                <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>
                    Training and mentorship to enhance your career growth.
                  </li>
                  <li>
                    Opportunity to work with a dynamic and supportive team.
                  </li>
                  <li>
                    Exposure to real-world sales and marketing strategies.
                  </li>
                </ul>
              </div>
            </div>
            <JobInformation />
          </div>
        </div>
      </div>

      <FormSection applyFormRef={applyFormRef} />
    </>
  );
};

export default JobDetails;
